export default [
  {
    id: 1,
    titleKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_ARTICLES.SSL_CERTIFICATE.TITLE',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Michael' },
    category: {
      slug: 'configuration',
      icon: 'i-lucide-package',
      nameKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_CATEGORIES.CONFIGURATION',
    },
    views: 3400,
  },
  {
    id: 2,
    titleKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_ARTICLES.FIRST_PORTAL.TITLE',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'John' },
    category: {
      slug: 'onboarding',
      icon: 'i-lucide-book-open',
      nameKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_CATEGORIES.ONBOARDING',
    },
    views: 400,
  },
  {
    id: 3,
    titleKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_ARTICLES.BEST_PRACTICES.TITLE',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'Fernando' },
    category: {
      slug: 'best-practices',
      icon: 'i-lucide-shield-check',
      nameKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_CATEGORIES.BEST_PRACTICES',
    },
    views: 400,
  },
  {
    id: 4,
    titleKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_ARTICLES.APPEARANCE.TITLE',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Jane' },
    category: {
      slug: 'design',
      icon: 'i-lucide-settings',
      nameKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_CATEGORIES.DESIGN',
    },
    views: 400,
  },
  {
    id: 5,
    titleKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_ARTICLES.THIRD_PARTY_TOOLS.TITLE',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Sarah' },
    category: {
      slug: 'integrations',
      icon: 'i-lucide-plug',
      nameKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_CATEGORIES.INTEGRATIONS',
    },
    views: 2800,
  },
  {
    id: 6,
    titleKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_ARTICLES.PERMISSIONS.TITLE',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Alex' },
    category: {
      slug: 'administration',
      icon: 'i-lucide-lock-keyhole',
      nameKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_CATEGORIES.ADMINISTRATION',
    },
    views: 1200,
  },
  {
    id: 7,
    titleKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_ARTICLES.FAQ_SECTIONS.TITLE',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Emily' },
    category: {
      slug: 'content-management',
      icon: 'i-lucide-file-text',
      nameKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_CATEGORIES.CONTENT_MANAGEMENT',
    },
    views: 5600,
  },
  {
    id: 8,
    titleKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_ARTICLES.SEARCH.TITLE',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'David' },
    category: {
      slug: 'features',
      icon: 'i-lucide-search',
      nameKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_CATEGORIES.FEATURES',
    },
    views: 1800,
  },
  {
    id: 9,
    titleKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_ARTICLES.ANALYTICS.TITLE',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Rachel' },
    category: {
      slug: 'analytics',
      icon: 'i-lucide-chart-no-axes-column',
      nameKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_CATEGORIES.ANALYTICS',
    },
    views: 3200,
  },
  {
    id: 10,
    titleKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_ARTICLES.MULTILINGUAL.TITLE',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Carlos' },
    category: {
      slug: 'localization',
      icon: 'i-lucide-globe',
      nameKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_CATEGORIES.LOCALIZATION',
    },
    views: 900,
  },
  {
    id: 11,
    titleKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_ARTICLES.TUTORIALS.TITLE',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Olivia' },
    category: {
      slug: 'education',
      icon: 'i-lucide-book-open',
      nameKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_CATEGORIES.EDUCATION',
    },
    views: 4100,
  },
  {
    id: 12,
    titleKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_ARTICLES.FEEDBACK.TITLE',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Nathan' },
    category: {
      slug: 'user-engagement',
      icon: 'i-lucide-message-circle',
      nameKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_CATEGORIES.USER_ENGAGEMENT',
    },
    views: 750,
  },
  {
    id: 13,
    titleKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_ARTICLES.SEO.TITLE',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Sophia' },
    category: {
      slug: 'seo',
      icon: 'i-lucide-search',
      nameKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_CATEGORIES.SEO',
    },
    views: 2900,
  },
  {
    id: 14,
    titleKey:
      'HELP_CENTER.NEW_PAGE.PREVIEW_ARTICLES.INTERNAL_KNOWLEDGE_BASE.TITLE',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'Daniel' },
    category: {
      slug: 'internal-resources',
      icon: 'i-lucide-building-2',
      nameKey: 'HELP_CENTER.NEW_PAGE.PREVIEW_CATEGORIES.INTERNAL_RESOURCES',
    },
    views: 1500,
  },
];
